var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayLargeCustomWarningErrorBase = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.504 13.605a5.55 5.55 0 0 1 6.334 2.624l34.453 61.25c.751 1.336.89 2.85.507 4.217a5.55 5.55 0 0 1-5.344 4.054H15.546a5.533 5.533 0 0 1-3.925-1.626 5.55 5.55 0 0 1-.913-6.645l34.454-61.25a5.533 5.533 0 0 1 3.34-2.624z",
    stroke: "#DD544A",
    strokeWidth: 6.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.5 32)",
    fill: "#DD544A"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#DD544A",
    strokeWidth: 2.5,
    x: 1.967,
    y: 36.138,
    width: 7.065,
    height: 7.612,
    rx: 3.533
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0a5.164 5.164 0 0 1 5.154 5.49L9.313 26.756a3.82 3.82 0 0 1-7.626 0L.347 5.49A5.164 5.164 0 0 1 5.5 0z",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayLargeCustomWarningErrorBase);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-large-custom-warning-errorBase.53e1c5e05aa65f5641588c1f393cc87f.svg";